import { createApiClient } from 'Network/ApiClient';

export const DrugsNotAllowedDrugsAxiosInstance = createApiClient('Drugs/');


